<div class="d-flex justify-content-start align-items-center">
    <app-zone-icon [color]="zone?.color"></app-zone-icon>
    <h2 class="m-0 ml-xm">{{zone.name}}</h2>
</div>
